export default "__VITE_ASSET__BuFAY4ie__"